<template>
  <b-sidebar
    id="add-new-cliente-sidebar"
    :visible="isAddNewClienteSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-cliente-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Adicionar novo Devedor
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >             
        
          <!-- Nome -->
          <validation-provider
            #default="validationContext"
            name="Nome"
            rules="required"
          >
            <b-form-group
              label="Nome"
              label-for="nome"
            >
              <b-form-input
                id="nome"
                v-model="clienteData.nome"
                autofocus
                :state="getValidationState(validationContext)"
                trim
                placeholder="John Doe"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Tipo Pessoa -->
          <validation-provider
            #default="validationContext"
            name="tipo_pessoa"
            rules="required"
          >
            <b-form-group
              label="Tipo Pessoa"
              label-for="tipo_pessoa"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="clienteData.tipo_pessoa"
                :options="tipoPessoaOptions"
                :reduce="val => val.value"
                :clearable="false"
                input-id="tipo_pessoa"
                state="false"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Documento -->
          <validation-provider
            #default="validationContext"
            name="Documento"
            rules="required"
          >
            <b-form-group
              label="Documento"
              label-for="documento"
            >
              <b-form-input
                id="documento"
                v-model="clienteData.documento"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Código -->
          <validation-provider
            #default="validationContext"
            name="Codigo"
            rules="required|alpha-num"
          >
            <b-form-group
              label="Codigo"
              label-for="codigo"
            >
              <b-form-input
                id="codigo"
                v-model="clienteData.codigo"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group> 
          </validation-provider>

          <!-- Situação -->
          <validation-provider
            #default="validationContext"
            name="Situacao"
            rules="required"
          >
            <b-form-group
              label="Situacação"
              label-for="situacao"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="clienteData.situacao"
                :options="situacaoOptions"
                :reduce="val => val.value"
                :clearable="false"
                input-id="situacao"
                state="false"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
                
          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              Adicionar
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancelar
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewClienteSidebarActive',
    event: 'update:is-add-new-cliente-sidebar-active',
  },
  props: {
    isAddNewClienteSidebarActive: {
      type: Boolean,
      required: true,
    },
    situacaoOptions: {
      type: Array,
      required: true,
    },
    tipoPessoaOptions: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      required,
      alphaNum,
      email
    }
  },
  setup(props, { emit }) {
    const blankClienteData = {
      nome: '',
      tipo_pessoa: null,
      documento: '',
      codigo: '',
      situacao: null,
      credor_id: 1
    }

    const clienteData = ref(JSON.parse(JSON.stringify(blankClienteData)))
    const resetclienteData = () => {
      clienteData.value = JSON.parse(JSON.stringify(blankClienteData))
    }

    const onSubmit = () => {
      store.dispatch('app-cliente/addCliente', clienteData.value)
        .then(() => {
          emit('refetch-data')
          emit('update:is-add-new-cliente-sidebar-active', false)
        })
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetclienteData)

    return {
      clienteData,
      onSubmit,

      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
